import script from "./CheckboxField.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxField.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxField.vue?vue&type=style&index=0&id=6b2a964c&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2a964c"]])

export default __exports__